export default __webpack_public_path__ + "static/media/logo-ecv.1967e4c7.svg";